// extracted by mini-css-extract-plugin
export default {"MenuWrapper":"Menu_MenuWrapper__IFsMy","MenuWrapper__Menu":"Menu_MenuWrapper__Menu__WObEi","MenuWrapper__Menu__item":"Menu_MenuWrapper__Menu__item__jJSuU","spin":"Menu_spin__LJmvU"};